module.exports = __webpack_public_path__ + "webfonts/398F09_0_unhinted_0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/webfonts/398F09_0_unhinted_0.woff2
// module id = 60
// module chunks = 0